import type { App } from 'vue'
import ButtonIcon from 'templates/Base/ButtonIcon.vue'
import ButtonWrapper from 'templates/Base/ButtonWrapper.vue'
import ReadMore from 'templates/ReadMore/ReadMore.vue'

export function registerGlobalComponents(app: App) {
	app.component('ButtonIcon', ButtonIcon)
	app.component('ButtonWrapper', ButtonWrapper)
	app.component('ReadMore', ReadMore)
}
